import { render, staticRenderFns } from "./InfoForm.vue?vue&type=template&id=422dae3e&"
import script from "./InfoForm.vue?vue&type=script&lang=js&"
export * from "./InfoForm.vue?vue&type=script&lang=js&"
import style0 from "./InfoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports